import { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom"
import { AnimatePresence } from "framer-motion";

// import './App.css';
// import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";


import './assets/css/critical.css';
import './assets/css/non-critical.css';
import './assets/css/custom.css';
import Home from "./partials/Pages/Home";
import ManagedOffice from "./partials/Pages/ManagedOffices";
import ConferenceHall from "./partials/Pages/ConferenceHall";
import DedicatedDesk from "./partials/Pages/DedicatedDesk";
import MeetingRoom from "./partials/Pages/MeetingRoom";
import PrivateCabins from "./partials/Pages/PrivateCabins";
import VirtualOffice from "./partials/Pages/VirtualOffice";
import Error from "./partials/components/Error";
import AOS from "aos";
import PrivacyPolicy from "./partials/Pages/PrivacyPolicy";
import TermsAndConditions from "./partials/Pages/TermsAndConditions";
import Services from "./partials/components/Services";
import ThankYou from "./partials/components/ThankYou";
const AnimatedRoutes = () => {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Home />} />
        <Route path="/managed-office" element={<ManagedOffice />} />
        <Route path="/conference-hall" element={<ConferenceHall />} />
        <Route path="/private-cabins" element={<PrivateCabins />} />
        <Route path="/dedicated-desk" element={<DedicatedDesk />} />
        <Route path="/meeting-room" element={<MeetingRoom />} />
        <Route path="/virtual-office" element={<VirtualOffice />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/services/:slug" element={<Services />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/thank-you" element={<ThankYou />} />
        <Route path="*" element={<Error />} />
      </Routes>
    </AnimatePresence>
  );
};
function App() {
  useEffect(() => {
    AOS.init({
      disable: "mobile", // Disables animations on mobile devices
      duration: 1000,    // Animation duration in milliseconds
      once: true,        // Animation runs only once
    });
    const handleSmoothScroll = (event) => {
      event.preventDefault();
      const targetId = event.currentTarget.getAttribute("href");
      const targetElement = document.querySelector(targetId);

      if (targetElement) {
        window.scrollTo({
          top: targetElement.offsetTop - 50,
          behavior: "smooth",
        });

        if (window.innerWidth < 992) {
          const navbarToggler = document.querySelector(".navbar-toggler");
          if (navbarToggler) {
            navbarToggler.click();
          }
        }
      }
    };

    const links = document.querySelectorAll("a.scroll-to");
    links.forEach((link) => link.addEventListener("click", handleSmoothScroll));

    return () => {
      links.forEach((link) =>
        link.removeEventListener("click", handleSmoothScroll)
      );
    };

    const handleScrollToTop = (event) => {
      event.preventDefault();
      window.scrollTo({ top: 0, behavior: "smooth" });
    };

    const scrollTopLinks = document.querySelectorAll("a[href='#top']");
    scrollTopLinks.forEach((link) => link.addEventListener("click", handleScrollToTop));

    return () => {
      scrollTopLinks.forEach((link) =>
        link.removeEventListener("click", handleScrollToTop)
      );
    };
  }, []);

  return (
    <>
      <Router>
        {/* <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/managed-office" element={<ManagedOffice />} />
        </Routes> */}
        <AnimatedRoutes />
      </Router>
    </>
  );
}

export default App;
